export const TEST_ID = 'tab';

export const ENTER_KEY = 'Enter';

export const SPACE_KEY = ' ';
